import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { SessionStorageService } from 'ngx-webstorage'; 
@Component({
  selector: 'cbic-service-tax',
  templateUrl: './service-tax.component.html', 
  styleUrls: ['./service-tax.component.scss']
})
export class ServiceTaxComponent implements OnInit {
  translateService: any;
  renderer: any;
  flag:any;
  color:any;
  
  //constructor() { }
  taxLegislationList?: ICbicContentMst[];
  onlineServiceList?: ICbicContentMst[];
  sericeCodes?:ICbicContentMst[];
  legacyList?:ICbicContentMst[];
  otherList?:ICbicContentMst[];
  lowsList?:ICbicContentMst[];  

  constructor(private sessionStorageService: SessionStorageService,private contentMstService : CbicContentMstService, private changeLnService: ChangeLanguageService) {} 

  isDataAvailable() {
    let dataAvailable = true;
    dataAvailable &&= this.taxLegislationList != null && this.taxLegislationList.length !== 0;
    if (dataAvailable) {
      dataAvailable &&= this.onlineServiceList != null && this.onlineServiceList.length !== 0;
    }
    if (dataAvailable) {
      dataAvailable &&= this.sericeCodes != null && this.sericeCodes.length !== 0;
    }
    if (dataAvailable) {
      dataAvailable &&= this.legacyList != null && this.legacyList.length !== 0;
    }
    if (dataAvailable) {
      dataAvailable &&= this.otherList != null && this.otherList.length !== 0;
    }
    if (dataAvailable) {
      dataAvailable &&= this.lowsList != null && this.lowsList.length !== 0;
    }
    return dataAvailable;
  };
  ngOnInit(): void {
    this.gettaxLegislation();
    this.getonlineService();
    this.getserviceCodes();
    this.getlegacy();
    this.getotherData();
    this.getcaseLows();
    this.color = this.sessionStorageService.retrieve('colr');
  }

  gettaxLegislation() :void{
    this.contentMstService.getContentData('Tax-serice-tax').subscribe(
      (res : HttpResponse<ICbicContentMst[]>) => {
        if(res.body){
          const usedLanguage = this.changeLnService.getLanguage();

          if (usedLanguage === 'hi') {
            this.flag ='Hi';
          } else {
            this.flag = 'En';
          }
          this.taxLegislationList = res.body;
        }
      }
    )
}

getonlineService() :void{
  this.contentMstService.getContentData('Online-service-tax').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        this.onlineServiceList = res.body;
      }
    }
  )
}

getserviceCodes() :void{
  this.contentMstService.getContentData('codes-service-tax').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        this.sericeCodes = res.body;
      }
    }
  )
}

getlegacy() :void{
  this.contentMstService.getContentData('Legacy-excise').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        this.legacyList = res.body;
      }
    }
  )
}

getotherData() :void{
  this.contentMstService.getContentData('Other-service-tax').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        this.otherList = res.body;
      }
    }
  )
}

getcaseLows() :void{
  this.contentMstService.getContentData('Case-lows-service-tax').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        this.lowsList = res.body;
      }
    }
  )
}

}
